<template>
    <div class="p-integrations">
        <div 
            :class="`integrations-close ${customCloseIconClass}`"
            v-if="showCloseIcon"
            @click="onCloseClick"
        >
            <svg-icon
                name="icons/close-black"
                original
                class="integrations-close__icon"
            />
        </div>
        <router-view />
    </div>
</template>

<script>

import {routerPushHandler} from "@/utils/helpers/common";
import { mapGetters, mapMutations, mapState } from 'vuex';
import {WEB_INTEGRATION} from "@/utils/constants/route-constants";
import {OBJECT_INFO_CLOSE_CLICK} from "@/utils/constants/bus-events-constants";

export default {
    name: 'PIntegrations',
    data() {
        return {
            showCloseIcon: false
        }
    },
    watch: {
        isAppLoaded () {
            this.checkCloseIcon()
        }
    },
    computed: {
        ...mapState([
            'isCloseIconShow'
        ]),
        ...mapGetters([
            'isAppLoaded',
            'getMapConfigProp'
        ]),
        isStore() {
            return this.$route.name.includes(WEB_INTEGRATION.STORE.ROOT.NAME)
        },
        customCloseIconClass() {
            if(this.$route.name == WEB_INTEGRATION.STORE.INFO.NAME) {
                return 'integrations-close--left-bottom'
            }
            return ''
        }
    },
    methods: {
        ...mapMutations([
            'setCloseIcon',
            'setMyPosition'
        ]),
        onCloseClick() {
            this.$bus.$emit(OBJECT_INFO_CLOSE_CLICK)
            const name = this.isStore ?
                WEB_INTEGRATION.STORE.INFO.NAME :
                WEB_INTEGRATION.CATALOGUE.LIST.NAME;
            this.$router.push({
                name,
                query: {
                    ...this.$route.query
                },
                routerPushHandler,
            });
        },
        checkMyPosition() {
            const MPosition = this.$route.query.mFrom
            if(MPosition && this.$route.query['redirect-from']) this.setMyPosition(MPosition)
        },
        checkCloseIcon() {
            const configIconShow = this.getMapConfigProp('components.PIntegrations.params.is_close_icon_show', false)
            if(this.$route.query['ui.close']) this.setCloseIcon(true)
            if(this.isCloseIconShow || configIconShow) this.showCloseIcon = true
        }
    },
    created() {
        this.checkMyPosition()
    }
}
</script>

<style lang="scss">
  @import "p-integrations";
</style>